var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-dashboard-projects"},[_c('Card',{staticClass:"section-title"},[_vm._v(" PROJECTS ")]),_c('Table',{attrs:{"columns":_vm.tblColumns,"data":_vm.tblData,"height":"250","size":"small","loading":_vm.isLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }